import { axiosGet } from '../ServiceBase.js';

export const getTiposCobertura = async () => {
  try {
    const tiposCobertura = await axiosGet('/v1/busquedas/tipos-coberturas');
    return tiposCobertura;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getTiposCoberturaDenuncia = async () => {
  try {
    const tiposCobertura = await axiosGet(`/v1/busquedas/tipos-coberturas/denuncias`);
    return tiposCobertura;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getTiposCoberturaReintegro = async () => {
  try {
    const tiposCobertura = await axiosGet(`/v1/busquedas/tipos-coberturas/reintegros`);
    return tiposCobertura;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getDocumentacionByTipoCobertura = async (idTipoCobertura) => {
  try {
    const tipoDocumentaciones = await axiosGet(
      `/v1/busquedas/tipos-coberturas/documentacion/${idTipoCobertura}`,
    );
    return tipoDocumentaciones;
  } catch (err) {
    console.error(err);
    return null;
  }
};
